import { useContext, useEffect, useRef } from 'react';
import { OwnershipContext } from '../contexts/OwnershipContext.js';
var useStableFramework = function useStableFramework(framework) {
    var ref = useRef(framework);
    if (JSON.stringify(ref.current) !== JSON.stringify(framework)) {
        ref.current = framework;
    }
    return ref.current;
};
export var useOwnership = function useOwnership() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, backendOwner = _ref.backendOwner, rawFramework = _ref.framework, frontendOwner = _ref.frontendOwner, invisible = _ref.invisible;
    var _context_backendOwner, _context_framework, _context_frontendOwner;
    var context = useContext(OwnershipContext);
    if (!context) {
        throw new Error('useOwnership must be used within an OwnershipProvider');
    }
    var framework = useStableFramework(rawFramework);
    // Save the status BEFORE making any changes
    var prevOwnership = useRef(null);
    var hasModified = useRef(false);
    // Save the initial state only if it has not yet been modified.
    if (prevOwnership.current === null && !hasModified.current) {
        var _context_backendOwner1, _context_framework1, _context_frontendOwner1;
        prevOwnership.current = {
            backendOwner: (_context_backendOwner1 = context.backendOwner) !== null && _context_backendOwner1 !== void 0 ? _context_backendOwner1 : null,
            framework: (_context_framework1 = context.framework) !== null && _context_framework1 !== void 0 ? _context_framework1 : null,
            frontendOwner: (_context_frontendOwner1 = context.frontendOwner) !== null && _context_frontendOwner1 !== void 0 ? _context_frontendOwner1 : null
        };
    }
    useEffect(function() {
        if (!invisible && (backendOwner || framework || frontendOwner)) {
            // Mark that the context has been modified
            hasModified.current = true;
            context.update({
                backendOwner: backendOwner !== null && backendOwner !== void 0 ? backendOwner : null,
                framework: framework !== null && framework !== void 0 ? framework : null,
                frontendOwner: frontendOwner !== null && frontendOwner !== void 0 ? frontendOwner : null
            });
        }
    }, [
        backendOwner,
        framework,
        frontendOwner,
        invisible
    ]);
    // When the component unmounts, restore the previous page
    useEffect(function() {
        return function() {
            if (hasModified.current && prevOwnership.current) {
                context.update(prevOwnership.current);
            }
        };
    }, [
        context.update
    ]);
    return {
        backendOwner: (_context_backendOwner = context.backendOwner) !== null && _context_backendOwner !== void 0 ? _context_backendOwner : null,
        framework: (_context_framework = context.framework) !== null && _context_framework !== void 0 ? _context_framework : null,
        frontendOwner: (_context_frontendOwner = context.frontendOwner) !== null && _context_frontendOwner !== void 0 ? _context_frontendOwner : null
    };
};

//# sourceMappingURL=useOwnership.js.map